import { render, staticRenderFns } from "./AxTitle.vue?vue&type=template&id=387f41ec&scoped=true"
import script from "./AxTitle.vue?vue&type=script&lang=ts"
export * from "./AxTitle.vue?vue&type=script&lang=ts"
import style0 from "./AxTitle.vue?vue&type=style&index=0&id=387f41ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f41ec",
  null
  
)

export default component.exports